module.exports = __webpack_public_path__ + "img/icon_twitter.05d15337.svg";